import { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Avatar,
  Tooltip,
  Button,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
  DashboardOutlined,
  CloudUploadOutlined,
} from "@mui/icons-material";
import LogoutOutlined from "@mui/icons-material/LogoutOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import axiosInstance from "../../lib/axios";
import {getRelativeTime} from "../../helpers"
import { useNavigate } from "react-router-dom";

const DRAWER_WIDTH = 240;
const COLLAPSED_WIDTH = 80;

export default function DashboardLayout({children, metaData = null, showHeader = false}) {
  const [open, setOpen] = useState(true);

  const toggleSidebar = () => setOpen((prev) => !prev);

  let last_updated_time = null
  if (metaData) {
   last_updated_time = getRelativeTime(metaData?.last_calculated_at)
  }

  const refreshDashboard = async () => {
    const response = await axiosInstance.get("/analytics/refresh");

    if (response.status === 200){
      // onRefreshCompleted()
      window.alert("Analytics being refreshed")
    }
  }

  const menuItems = [
    { label: "Dashboard", link: "/", icon: <DashboardOutlined /> },
    // { label: "Inventory", link: "/inventory", icon: <Inventory2Outlined /> },
    { label: "Import Data", link: "/import-data", icon: <CloudUploadOutlined /> },
    // { label: "Settings", link: "/settings", icon: <SettingsOutlined /> },
    // { label: "Alerts", link: "/alerts", icon: <NotificationsNoneOutlined /> },
  ];

  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"))

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token"); // if you store it
    navigate("/login");
  };

  return (
    <Box sx={{ display: "flex" }}>
      {/* SIDEBAR */}
      <Box
        sx={{
          width: open ? DRAWER_WIDTH : COLLAPSED_WIDTH,
          transition: "width 0.25s ease",
          bgcolor: "#0B0B09",
          color: "rgba(247,244,238,0.85)",
          maxHeight: "100vh",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          borderRight: "1px solid rgba(255,255,255,0.06)",
          position: "sticky",
          top: 0
        }}
      >
        {/* TOP */}
        <Box>
          <Box
            sx={{
              px: 2,
              py: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: open ? "space-between" : "center",
            }}
          >
            {open && (
              <Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "#F7F4EE",
                  }}
                >
                  StockMove
                </Typography>

                <Typography
                  sx={{
                    fontSize: "11px",
                    color: "rgba(247,244,238,0.4)",
                  }}
                >
                  Inventory Intelligence
                </Typography>
              </Box>
            )}

            <IconButton onClick={toggleSidebar} sx={{ color: "#F7F4EE" }}>
              {open ? <ChevronLeftIcon /> : <MenuIcon />}
            </IconButton>
          </Box>

          <Divider sx={{ borderColor: "rgba(255,255,255,0.06)" }} />

          {/* NAV */}
          <List sx={{ px: 1.5, py: 2 }}>
            {menuItems.map((item, i) => (
              <Tooltip title={!open ? item.label : ""} placement="right" key={i}>
                <ListItemButton
                  onClick={() => navigate(item?.link)}
                  sx={{
                    borderRadius: 2,
                    mb: 0.5,
                    px: 2,
                    minHeight: 44,
                    justifyContent: open ? "initial" : "center",
                    color: "rgba(247,244,238,0.6)",

                    "&:hover": {
                      bgcolor: "rgba(255,255,255,0.06)",
                      color: "#F7F4EE",
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 2 : 0,
                      justifyContent: "center",
                      color: "inherit",
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>

                  {open && (
                    <ListItemText
                      primary={item.label}
                      primaryTypographyProps={{
                        fontSize: 13,
                        fontWeight: 500,
                      }}
                    />
                  )}
                </ListItemButton>
              </Tooltip>
            ))}
          </List>
        </Box>

        {/* BOTTOM */}
        <Box sx={{ p: 1.5 }}>
          <Divider sx={{ borderColor: "rgba(255,255,255,0.06)", mb: 1.5 }} />

          <Tooltip title={!open ? "Logout" : ""} placement="right">
    <ListItemButton
      onClick={handleLogout}
      sx={{
        borderRadius: 2,
        mb: 1,
        px: 2,
        minHeight: 44,
        justifyContent: open ? "initial" : "center",
        color: "rgba(247,244,238,0.6)",

        "&:hover": {
          bgcolor: "rgba(255,255,255,0.06)",
          color: "#F7F4EE",
        },
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: 0,
          mr: open ? 2 : 0,
          justifyContent: "center",
          color: "inherit",
        }}
      >
        <LogoutOutlined />
      </ListItemIcon>

      {open && (
        <ListItemText
          primary="Logout"
          primaryTypographyProps={{
            fontSize: 13,
            fontWeight: 500,
          }}
        />
      )}
    </ListItemButton>
  </Tooltip>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: open ? 1.5 : 0,
              justifyContent: open ? "flex-start" : "center",
            }}
          >
            <Avatar
              sx={{
                width: 34,
                height: 34,
                bgcolor: "#1B3A2D",
                color: "#E8F0EB",
                fontSize: 12,
                fontWeight: 600,
                textTransform: "capitalize"
              }}
            >
              {user?.username[0]}
            </Avatar>

            {open && (
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  sx={{
                    fontSize: 12.5,
                    fontWeight: 500,
                    color: "#F7F4EE",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                   {user?.username}
                </Typography>

                <Typography
                  sx={{
                    fontSize: 11,
                    color: "rgba(247,244,238,0.35)",
                  }}
                >
                  {user?.email}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      {/* MAIN CONTENT */}
      <Box
        sx={{
          flex: 1,
          bgcolor: "background.default",
          p: 3,
        }}
      >
        {showHeader &&
              <Box
          sx={{
            mb: 3,
            px: 2.5,
            py: 1.5,
            borderRadius: 1,
            bgcolor: "background.paper",
            border: "1px solid",
            borderColor: "divider",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* LEFT: Title + status */}
          <Box>
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 600,
                color: "text.primary",
                lineHeight: 1.2,
              }}
            >
              Dashboard
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
              <Box
                sx={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  bgcolor: "success.main",
                }}
              />

              <Typography
                sx={{
                  fontSize: 12,
                  color: "text.secondary",
                }}
              >
               Last Updated {last_updated_time}
              </Typography>
            </Box>
          </Box>

          {/* RIGHT: Actions */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Button
              onClick={refreshDashboard}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                px: 1.25,
                py: 0.5,
                borderRadius: 2,
                cursor: "pointer",
                color: "text.secondary",
                transition: "all 0.2s ease",

                "&:hover": {
                  bgcolor: "action.hover",
                  color: "text.primary",
                },
              }}
            >
              <RefreshIcon sx={{ fontSize: 16 }} />

              <Typography
                sx={{
                  fontSize: 12.5,
                  fontWeight: 500,
                }}
              >
                Refresh
              </Typography>
            </Button>

            <Avatar
              sx={{
                width: 32,
                height: 32,
                fontSize: 12,
                bgcolor: "#1B3A2D",
                color: "#E8F0EB",
                textTransform: "capitalize"
              }}
            >
             {user?.username[0]}
            </Avatar>
          </Box>
        </Box> }
        {children}
      </Box>
    </Box>
  );
}